import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { PropTypes } from 'mobx-react'
import { Form, Input } from 'formsy-react-components';
import Parse from 'parse';

import styled from 'styled-components'
// import cssVar from '../../styles/variables'

import { ImageHeader, ImageHeading } from '../components/OnePager/ImageSectionStyle'
import { IconContainer } from './KontaktStyle'
import { LogeButton, NavSpacer, Center, LightBackground, Black, BlackHeading, WappenLogo, Icon, GoldHeading } from '../components/GeneralStyle'

import headerImage from '../images/kontakt_headerimage.jpg'
import mapIcon from '../images/icons/map_lg_gold.png'
import persIcon from '../images/icons/person_double_lg_gold.png'

import ContactSuccessModal from '../components/ContactSuccessModal'
import DataPrivDisclaimer from '../components/DataPrivDisclaimer'

class Kontakt extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isSent: false,
    }
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit = (data) => {
    Parse.Cloud.run('sendContactMail', {
      firstname: data.firstname,
      lastname: data.lastname,
      email: data.email,
      phone: data.phone,
      message: data.message
    })
      .then(
        this.setState({ isSent: true }),
        this.contactsuccessmodal.openModal(data.firstname, data.lastname)
      )
      .catch(error => {
        console.error("error", error)
      })
  }

  render() {
    const isDefaultRequiredValue = 'Das ist ein Pflichtfeld.'

    return (
      <Grid fluid>
        <NavSpacer />
        <LightBackground>
          <FontWrapper>
          <ImageHeader height={350} background={headerImage}>
            <ImageHeading>KONTAKT</ImageHeading>
          </ImageHeader>


          <Row style={{ padding: 100 }}>
            <div className={'content-wrapper'}>
              <Col lg={6} md={6} sm={6} xs={12}>
                <WappenLogo style={{ marginLeft: "auto" }} size={180} />
              </Col>
              <Col lg={6} md={6} sm={6} xs={12}>
                <BlackHeading style={{ textAlign: "left" }}><strong>THE LOGE GmbH</strong></BlackHeading>
                <Black>the exclusive business & lifestyle network</Black>
                <IconContainer>
                  <Icon icon={mapIcon} size={24} />
                  <Black style={{ paddingLeft: 45 }}>Badeteich Hofstädter 8a, 2353 Guntramsdorf</Black>
                </IconContainer>
                <IconContainer>
                  <Icon size={24} />
                  <Black style={{ paddingLeft: 45 }}><a href="tel:00436769444481">+43 676 944 44 81</a></Black>
                </IconContainer>
                <IconContainer>
                  <Icon icon={persIcon} size={24} />
                  <Black style={{ paddingLeft: 45 }}><a href="mailto:kontakt@the-loge.com">kontakt@the-loge.com</a></Black>
                </IconContainer>

              </Col>

            </div>
          </Row>
          <div style={{borderBottom: '1px solid #212C3C', width:'50%', margin:'auto'}}>

          </div>
          <Row style={{ padding: 50 }}>
            <div className={'content-wrapper'}>
              <Col lg={8} md={12} sm={12} lgOffset={2}>
                <GoldHeading style={{ textAlign: 'center' }}>Treten Sie mit uns in Kontakt</GoldHeading>
                <Form
                  style={{ width: "100%", margin: "0px auto", maxWidth: 900 }}
                  onSubmit={this.onSubmit}
                  layout={'vertical'}
                  validateOnSubmit={true}
                  validatePristine={false}
                >
                  <Row >
                    <Col lg={6} md={6} sm={6} className={"no-side-padding"} style={{ paddingRight: 40, paddingLeft: 40 }}>
                      <Input
                        name="firstname"
                        value=""
                        type="text"
                        placeholder="Vorname"
                        validationErrors={{ isDefaultRequiredValue }}
                        required
                      />
                    </Col>
                    <Col lg={6} md={6} sm={6} className={"no-side-padding"} style={{ paddingRight: 40, paddingLeft: 40 }}>
                      <Input
                        name="lastname"
                        value=""
                        type="text"
                        validationErrors={{ isDefaultRequiredValue }}
                        placeholder="Nachname"
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} md={6} sm={6} className={"no-side-padding"} style={{ paddingRight: 40, paddingLeft: 40 }}>
                      <Input
                        name="email"
                        value=""
                        type="text"
                        placeholder="E-Mail"
                        validationErrors={{ isDefaultRequiredValue }}
                        required
                      />
                    </Col>
                    <Col lg={6} md={6} sm={6} className={"no-side-padding"} style={{ paddingRight: 40, paddingLeft: 40 }}>
                      <Input
                        name="phone"
                        value=""
                        type="text"
                        validationErrors={{ isDefaultRequiredValue }}
                        placeholder="Telefon"
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                  <Col sm={12} className={"no-side-padding"} style={{ paddingRight: 40, paddingLeft: 40 }}>
                    <Input
                      name="message"
                      value=""
                      type="text"
                      validationErrors={{ isDefaultRequiredValue }}
                      placeholder="Ihre Nachricht"
                      required
                    />
                  </Col>
                  </Row>
                  <Row>
                  <DataPrivDisclaimer />
                  <Center marginTop={50} marginBottom={50}>
                    <LogeButton
                      hoverFontColor={"white"}
                      type="submit">absenden</LogeButton>
                  </Center>

                  </Row>
                </Form>
              </Col>
            </div>
          </Row>
          </FontWrapper>

        </LightBackground>
        <ContactSuccessModal onRef={ref => (this.contactsuccessmodal = ref)} />
      </Grid>
    )
  }
}

Kontakt.propTypes = {
  appStore: PropTypes.observableObject
};

const FontWrapper = styled.div `
  * {
    font-family: 'Supreme-Regular';
  }
`

export default Kontakt



// WEBPACK FOOTER //
// /src/pages/Kontakt.js